__turbopack_context__.v({
  "overhead": "overhead-component-module-scss-module__8J6JxW__overhead",
  "overhead--black": "overhead-component-module-scss-module__8J6JxW__overhead--black",
  "overhead--green": "overhead-component-module-scss-module__8J6JxW__overhead--green",
  "overhead--main": "overhead-component-module-scss-module__8J6JxW__overhead--main",
  "overhead--pink": "overhead-component-module-scss-module__8J6JxW__overhead--pink",
  "overhead__close-btn": "overhead-component-module-scss-module__8J6JxW__overhead__close-btn",
  "text": "overhead-component-module-scss-module__8J6JxW__text",
});
